export type FeatureIcon = "action" | "resolve" | "narrate";

export interface FeatureItem {
  titleKey: string;
  bodyKey: string;
  index: string;
  icon?: FeatureIcon;
}

export interface RoadmapItem extends FeatureItem {
  statusKey: string;
}

export interface TermsSection {
  titleKey: string;
  bodyKeys: string[];
}

export const HOW_IT_WORKS: FeatureItem[] = [
  { index: "01", icon: "action", titleKey: "landing.how.actionTitle", bodyKey: "landing.how.actionBody" },
  { index: "02", icon: "resolve", titleKey: "landing.how.resolveTitle", bodyKey: "landing.how.resolveBody" },
  { index: "03", icon: "narrate", titleKey: "landing.how.narrateTitle", bodyKey: "landing.how.narrateBody" },
];

export const DIFFERENTIATORS: FeatureItem[] = [
  { index: "A", titleKey: "landing.difference.engineTitle", bodyKey: "landing.difference.engineBody" },
  { index: "B", titleKey: "landing.difference.campaignTitle", bodyKey: "landing.difference.campaignBody" },
];

export const ROADMAP_ITEMS: RoadmapItem[] = [
  { index: "I", statusKey: "landing.roadmap.active", titleKey: "landing.roadmap.alphaTitle", bodyKey: "landing.roadmap.alphaBody" },
  { index: "II", statusKey: "landing.roadmap.next", titleKey: "landing.roadmap.polishTitle", bodyKey: "landing.roadmap.polishBody" },
  { index: "III", statusKey: "landing.roadmap.planned", titleKey: "landing.roadmap.contentTitle", bodyKey: "landing.roadmap.contentBody" },
  { index: "IV", statusKey: "landing.roadmap.future", titleKey: "landing.roadmap.accessTitle", bodyKey: "landing.roadmap.accessBody" },
];

export const TERMS_SECTIONS: TermsSection[] = [
  { titleKey: "landing.terms.alphaTitle", bodyKeys: ["landing.terms.alphaBody"] },
  { titleKey: "landing.terms.accountsTitle", bodyKeys: ["landing.terms.accountsBody"] },
  { titleKey: "landing.terms.contentTitle", bodyKeys: ["landing.terms.contentBody"] },
  { titleKey: "landing.terms.conductTitle", bodyKeys: ["landing.terms.conductBody"] },
  { titleKey: "landing.terms.tokensTitle", bodyKeys: ["landing.terms.tokensBody"] },
  { titleKey: "landing.terms.ipTitle", bodyKeys: ["landing.terms.ipBody"] },
  { titleKey: "landing.terms.terminationTitle", bodyKeys: ["landing.terms.terminationBody"] },
  { titleKey: "landing.terms.disclaimerTitle", bodyKeys: ["landing.terms.disclaimerBody"] },
  { titleKey: "landing.terms.contactTitle", bodyKeys: ["landing.terms.contactBody"] },
];
